// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var NOT_SELECTED = -1;
var hasSameFlags = function (a, b) {
    return Boolean(a.is_explicit_invalid) === Boolean(b.is_explicit_invalid) &&
        Boolean(a.is_decline_to_vote) === Boolean(b.is_decline_to_vote) &&
        Boolean(a.is_blank_ballot) === Boolean(b.is_blank_ballot);
};
var getMarks = function (contest) {
    return new Map(contest.choices
        .filter(function (choice) { return choice.selected > NOT_SELECTED; })
        .map(function (choice) { var _a; return [choice.id, "".concat(choice.selected, ":").concat((_a = choice.write_in_text) !== null && _a !== void 0 ? _a : "")]; }));
};
var hasSameMarks = function (a, b) {
    var marksOfA = getMarks(a);
    var marksOfB = getMarks(b);
    return (marksOfA.size === marksOfB.size &&
        Array.from(marksOfA).every(function (_a) {
            var id = _a[0], mark = _a[1];
            return marksOfB.get(id) === mark;
        }));
};
/**
 * Whether two ballot selections are the same vote: the same candidates with
 * the same ranks and write-in texts, and the same contest flags. The order of
 * contests and choices does not matter, and neither do validation messages.
 */
export var isSameBallotSelection = function (a, b) {
    return a.length === b.length &&
        a.every(function (contest) {
            var other = b.find(function (entry) { return entry.contest_id === contest.contest_id; });
            return !!other && hasSameFlags(contest, other) && hasSameMarks(contest, other);
        });
};
